// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-01ee15b6] .el-drawer:focus {\n  outline: none;\n}\n[data-v-01ee15b6] .el-drawer__body {\n  overflow-y: auto;\n}\n", ""]);
// Exports
module.exports = exports;
